import { useCloseModal, useConfigureModalController, useModalController } from '@/atoms'
import { useState } from 'react'

type ModalStatus = 'ready'

interface ModalData {
  depotIds: string[]
}

type ModalProps = {
  depotIds: string[]
}

export const modalId = 'deleteDepot'
export const useController = () => useModalController<ModalData, ModalStatus>(modalId)

export const useConfigureController = ({ depotIds }: ModalProps) => {
  const close = useCloseModal()

  const [options] = useState(() => ({
    createInitialState: () => ({
      status: 'ready' as ModalStatus,
      data: { depotIds },
      close,
    }),
  }))

  return useConfigureModalController<ModalData, ModalStatus>(modalId, options)
}
